// extracted by mini-css-extract-plugin
module.exports = {"HalfHalf":"half-half_HalfHalf__UXJB6","evolved":"half-half_evolved__pOFOu"};